import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/styles';
import { hideModal } from '../../../actions/runtime';
import UserChoiceContent from './UserChoice';
import { breakpoints } from '~/core/util/styledComponents';

export const USER_CHOICE_MODAL_ID = 'user choice modal';

type Props = {
  open?: boolean;
  fullScreen?: boolean;
  onClose?: () => void;
  fromSrp?: boolean;
  results?: any[];
};

const StyledDialog = withStyles((theme) => ({
  paper: {
    borderRadius: 24,
    [theme.breakpoints.down('sm')]: {
      borderRadius: 0,
    },
  },
}))(Dialog);

const UserChoice = ({ open = false, fullScreen, onClose, fromSrp, results = [] }: Props) => {
  return results.length > 0 ? (
    <StyledDialog fullScreen={fullScreen} maxWidth="xl" onClose={onClose} open={open} scroll="body">
      <UserChoiceContent fromSrp={fromSrp} onClickBack={onClose} results={results} />
    </StyledDialog>
  ) : null;
};

export default connect(
  (state: any) => ({
    open: state.runtime.modal && !!state.runtime.modal[USER_CHOICE_MODAL_ID],
  }),
  (dispatch: any) => ({
    onClose: () => dispatch(hideModal(USER_CHOICE_MODAL_ID)),
  })
)(withMobileDialog({ breakpoint: 'xs' })(UserChoice));
